import React, { InputHTMLAttributes, memo } from 'react'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Input.scss'
const rootClassName = 'component-input'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  value?: string | number
  loading?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  label?: string
  placeholder?: string
  type?: string
  counter?: boolean
  maxLength?: number
  rightObject?: React.ReactNode
  hideLabelAndHelperText?: boolean
  forceFocus?: boolean
}

function Input(props: InputProps) {
  const getProps = () => {
    const p = {
      ...props,
      id: props.id ? `${props.id}-input` : undefined,
      className: getMergedClassNames([
        'nunito',
        `${rootClassName}-input`,
        props.className || ''
      ])
    }
    delete p.loading
    delete p.error
    delete p.helperText
    delete p.label
    delete p.counter
    delete p.rightObject
    delete p.hideLabelAndHelperText
    delete p.forceFocus
    return p
  }

  const getContainerClassNames = () =>
    getMergedClassNames([
      rootClassName,
      props.error ? `${rootClassName}-error` : '',
      props.loading ? `${rootClassName}-loading` : '',
      props.disabled ? `${rootClassName}-disabled` : '',
      props.forceFocus ? 'force-focus' : ''
    ])

  return (
    <div id={props.id} className={getContainerClassNames()}>
      {!props.hideLabelAndHelperText && (
        <div className={`${rootClassName}-label nunito`}>
          {props.label || ''}
        </div>
      )}
      <div className={`${rootClassName}-input-container`}>
        <input {...getProps()} />
        {props.rightObject && (
          <div className={`${rootClassName}-right-object`}>
            {props.rightObject}
          </div>
        )}
      </div>
      {!props.hideLabelAndHelperText && (
        <div className={`${rootClassName}-helper-and-counter`}>
          <div className={`${rootClassName}-helper-text nunito`}>
            {props.helperText || ''}
          </div>
          {props.counter && (
            <div className={`${rootClassName}-counter`}>
              {`${String(props.value || '').length}${
                props.maxLength || props.maxLength === 0
                  ? `/${props.maxLength}`
                  : ''
              }`}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

Input.defaultProps = {
  onChange: () => {},
  value: '',
  loading: false,
  error: false,
  helperText: '',
  label: '',
  placeholder: '',
  type: 'text',
  forceFocus: false
}

export default memo(Input)
